import { render } from "./FilosofiaEng.vue?vue&type=template&id=67c3920e"
import script from "./FilosofiaEng.vue?vue&type=script&lang=js"
export * from "./FilosofiaEng.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__